import { IoCloseCircle, IoFunnelOutline } from 'react-icons/io5';
import { formatReadDate } from '../../utils/reportFormat';
import ReportFilters from './ReportFilters';
import './reports.css';

const FILTER_LABELS = {
  startDate: (value) => `From ${formatReadDate({ readDate: value })}`,
  endDate: (value) => `To ${formatReadDate({ readDate: value })}`,
  testament: (value) => `${value} Testament`,
  book: (value) => value
};

/** Count, Filters and Select on one row, with a chip for each active filter. */
const ReportsToolbar = ({
  total,
  filters,
  onFiltersChange,
  onClearFilters,
  filtersOpen,
  onToggleFilters,
  selectMode,
  onToggleSelect,
  canSelect
}) => {
  const active = Object.keys(FILTER_LABELS).filter((key) => filters[key]);

  return (
    <div className="report-toolbar">
      <div className="report-toolbar-row">
        <p className="report-total">{total.toLocaleString()} {total === 1 ? 'report' : 'reports'}</p>
        <div className="report-toolbar-actions">
          <button
            type="button"
            className="report-btn"
            aria-expanded={filtersOpen}
            aria-controls="report-filter-panel"
            onClick={onToggleFilters}
          >
            <IoFunnelOutline aria-hidden="true" /> Filters
            {active.length > 0 && <span className="report-badge">{active.length}</span>}
          </button>
          {canSelect && (
            <button
              type="button"
              className={`report-btn ${selectMode ? 'report-btn--primary' : ''}`}
              aria-pressed={selectMode}
              onClick={onToggleSelect}
            >
              {selectMode ? 'Done' : 'Select'}
            </button>
          )}
        </div>
      </div>

      {filtersOpen && (
        <div id="report-filter-panel">
          <ReportFilters filters={filters} onChange={onFiltersChange} />
        </div>
      )}

      {active.length > 0 && (
        <ul className="report-chips" aria-label="Active filters">
          {active.map((key) => (
            <li key={key}>
              <button
                type="button"
                className="report-chip"
                onClick={() => onFiltersChange({ [key]: '' })}
                aria-label={`Remove filter: ${FILTER_LABELS[key](filters[key])}`}
              >
                {FILTER_LABELS[key](filters[key])}
                <IoCloseCircle aria-hidden="true" />
              </button>
            </li>
          ))}
          <li>
            <button type="button" className="report-link" onClick={onClearFilters}>Clear</button>
          </li>
        </ul>
      )}
    </div>
  );
};

export default ReportsToolbar;
